<div class="container" id="spinerLoader" *ngIf="loader">
  <div class="loader">Loading...</div>
</div>

<div>
  <section class="content-header row">
    <div class="col-md-12 box-header">
      <h2 class=" box-title">
        <strong>Manage Customer</strong>
      </h2>
      <div class="pull-right box-tools"
        *ngIf="user.role !== 'Customer Admin' && user.role !== 'Customer Coordinator' && !isInternalReadOnly">
        <button class="header-btn" type="submit" title="Add Members" (click)="openAddCustomer('Add Customer', false)"
          style="width:auto !important">
          <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i><span style="padding-left: 5px;">Customer</span>
        </button>
      </div>
    </div>
  </section>
  <section class="content footerPosition">
    <div class="row">
      <div class="col-xs-12">
        <div class="card card-layout-tab">
          <div class="card-layout card-margin"
            *ngIf="user.role != 'Customer Admin' && user.role != 'Customer Coordinator'">
            <div>
              <h4 class="filter-content-container row">Filter Options</h4>
              <hr class="horizontal-line-style" />
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                  <div>
                    <label>Name</label>
                    <ng-multiselect-dropdown-angular7 [placeholder]="'Name'" [settings]="dropdownSettingsForName"
                      [data]="customerNameList" [(ngModel)]="selectedCustomerItem">
                    </ng-multiselect-dropdown-angular7>
                  </div>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4">
                  <div>
                    <label>City</label>
                    <ng-multiselect-dropdown-angular7 [placeholder]="'City'" [settings]="cityDropdownSettings"
                      [data]="cities" [(ngModel)]="selectCity">
                    </ng-multiselect-dropdown-angular7>
                  </div>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4">
                  <div>
                    <label>State</label>
                    <ng-multiselect-dropdown-angular7 [placeholder]="'State'" [settings]="dropdownSettings"
                      [data]="StateList" [(ngModel)]="selectedState">
                    </ng-multiselect-dropdown-angular7>
                  </div>
                </div>
                <div class="col-md-4 col-lg-1 col-sm-4 margin-top-5">
                  <div>
                    <div class="">
                      <label style="color:white"> .</label>
                      <button type="submit" id="close"
                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn" style="font-size:14px"
                        (click)="currentPage = 1; applyFilter()">Apply</button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-lg-1 col-sm-4 margin-top-5">
                  <div>
                    <div class="form-group">
                      <label style="color:white"> .</label>
                      <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt w-100 flat-danger-butt"
                        style="font-size:14px" (click)="clearFilter()">Clear</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row filter-section">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="col-xl-7 col-lg-6 col-md-6 col-sm-8 col-xs-8">
                <div class="">
                  Show
                  <select name="example1_length" aria-controls="example1"
                    class="margin-left-7 custom-select custom-select-sm grid-header-element number-sort-filter"
                    (change)="selectedPageCurrent()" [(ngModel)]='selectedPage'>
                    <option *ngFor="let number of numberOfEntries" [value]="number">
                      {{number}}
                    </option>
                  </select>
                  entries
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-xs-4">
                <span class="text-color text-color1 cursorPointer mt-2 pb-2" (click)="showAllCustomer()"
                  style="float:right">{{this.dataFilter.isShowAllCustomers==false?'Show All':'Show Active'}}</span>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div id="example1_filter" class="d-flex" style="float:right">
                  Search<input type="text" id="searchInput"
                    class="margin-left-7 form-control form-control-sm grid-header-element searchbar-element"
                    aria-controls="example1" [(ngModel)]="searchText">
                </div>
              </div>
            </div>
          </div>

          <div class="card-body-tab">
            <div class="col-12 px-2">
              <div class="cards-body">
                <div class="tableSpacing">
                  <div class="box-body">
                    <table id="example1" class="table card-layout table-striped table">
                      <thead>
                        <tr>
                          <td class="header_td table_heading">
                            <div class="header_container text-primary">
                              <div class="header_title cursorPointer"
                                (click)="sortBy='name'; sortOrder = !sortOrder; name = !name;">
                                Name
                                <i *ngIf="name==true;" class="fa fa-chevron-up margin-left-7"></i>
                                <i *ngIf="name==false;" class="fa fa-chevron-down margin-left-7"></i>
                              </div>
                              <div class="header_title cursorPointer"
                                (click)="sortBy='contact.primaryContact'; sortOrder = !sortOrder; primaryContact = !primaryContact;">
                                Phone
                                <i *ngIf="primaryContact==true;" class="fa fa-chevron-up margin-left-7"></i>
                                <i *ngIf="primaryContact==false;" class="fa fa-chevron-down margin-left-7"></i>
                              </div>
                              <div class="header_title cursorPointer"
                                (click)="sortBy='contact.customerTypeName'; sortOrder = !sortOrder; type = !type;">
                                Type
                                <i *ngIf="type==true;" class="fa fa-chevron-up margin-left-7"></i>
                                <i *ngIf="type==false;" class="fa fa-chevron-down margin-left-7"></i>
                              </div>
                              <div class="header_title cursorPointer"
                                (click)="sortBy='contact.emailId'; sortOrder = !sortOrder; email = !email;">
                                Email
                                <i *ngIf="email==true;" class="fa fa-chevron-up margin-left-7"></i>
                                <i *ngIf="email==false;" class="fa fa-chevron-down margin-left-7"></i>
                              </div>
                              <div class="header_title" *ngIf="user.role != 'Customer Coordinator'">Action</div>
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let customer of customerList | orderBy: sortBy:sortOrder | paginate: {itemsPerPage: selectedPage, currentPage:currentPage, totalItems: totalCount } ; let i=index">
                          <td>
                            <div class="row_container">
                              <div class="title_container" [ngClass]="{'inactive_vendor':customer.isEnable==false}">
                                <div class="row_title">Name</div>
                                <div class="row_detail">
                                  <a class="cursorPointer text-color" *ngIf="!isInternalReadOnly"
                                    href="{{url}}/common-details/customer/{{customer.customerId}}"
                                    (click)="openVendorDetailPage(customer.customerId)">{{customer.name}}</a>
                                  <span *ngIf="isInternalReadOnly">{{customer.name}}</span>
                                </div>
                              </div>
                              <div class="title_container" [ngClass]="{'inactive_vendor':customer.isEnable==false}">
                                <div class="row_title">Phone</div>
                                <div class="row_detail">
                                  <a *ngIf="!isInternalReadOnly" class="phonenumberlink"
                                    href="tel:+1{{customer.contact.phone}}">
                                    {{customer.contact.phone | phoneNumberPipe}}
                                  </a>
                                  <span *ngIf="isInternalReadOnly">
                                    {{customer.contact.phone | phoneNumberPipe}}
                                  </span>
                                </div>
                              </div>
                              <div class="title_container" [ngClass]="{'inactive_vendor':customer.isEnable==false}">
                                <div class="row_title">Type</div>
                                <div class="row_detail" style="word-break:break-all;">
                                  {{customer.customerTypeName}}
                                </div>
                              </div>
                              <div class="title_container" [ngClass]="{'inactive_vendor':customer.isEnable==false}">
                                <div class="row_title">Email</div>
                                <div class="row_detail" style="word-break:break-all;">
                                  {{customer.contact.emailId}}
                                </div>
                              </div>
                              <div class="title_container" *ngIf="user.role != 'Customer Coordinator'">
                                <div class="row_title">Action</div>
                                <div class="row_detail">
                                  <div *ngIf="user.role != 'Customer Admin'
                                  && user.role !='Coordinator'
                                  && user.role !='Management'"
                                    class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer py-1 px-1 pb-0 "
                                    [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                    [title]="customer.isEnable == true?'Disable Customer':'Enable Customer'">
                                    <div class="checkbox checbox-switch switch-danger my-0 py-0">
                                      <label [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''">
                                        <input type="checkbox" name=""
                                          [checked]="customer.isEnable == true ? true : false"
                                          [disabled]="isInternalReadOnly"
                                          (change)="disableCustomer(customer.customerId,$event)" />
                                        <span></span>
                                      </label>
                                    </div>
                                  </div>
                                  <button class="flat-butt flat-info-butt flat-info-grad-butt pt-1"
                                    title="Edit Customer" [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                    (click)="openEditCustomer('Edit Customer',true ,customer,customer.customerId)"
                                    [disabled]="(customer.isEnable == false ? true : false) || isInternalReadOnly">
                                    <i class="fa fa-pencil-square"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                    </table>
                    <div style="color: #a82b41" class="mt-2" *ngIf="(customerList ).length==0">
                      <b>No Record Found</b>
                    </div>
                    <div class="col-md-12 p-0" style="margin-top:10px"
                      *ngIf="customerList.length>0">
                      <div class="col-md-6 p-0">
                        {{pagination}}
                      </div>

                      <div class="col-md-6 pagination text-end mt-1">
                        <pagination-controls [maxSize]="6" [previousLabel]="''" [nextLabel]="''"
                          [responsive]="responsive" (pageChange)="currentPage = $event;currentPageChange()">
                        </pagination-controls>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
